module.exports = __webpack_public_path__ + "static/img/wl-footer-img.50dd4c25.png";